import { getDownloadURL, listAll, ref } from "firebase/storage";
import { storage } from "../firebase";
// servicesPage.service1.title
// servicesPage.service1.bulletPoints1
export const services = [
  {
    icon: "assets/img/icon/eye.png",
    // Microincision Cataract Surgery
    title: "title",
    sortOrder: "1",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    paragraph3: "paragraph3",
    bulletPoints3: "bulletPoints3",
    image: "MISC Surgery.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // LASIK Surgery
    title: "title",
    sortOrder: "2",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image: "Eye Lens Iris.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Phakic IOL and ICL
    title: "title",
    sortOrder: "3",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    paragraph3: "paragraph3",
    bulletPoints3: "bulletPoints3",
    image: "OccularZoom.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Glaucoma Treatment
    title: "title",
    sortOrder: "4",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image: "Glaucoma2.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Retina & Vitreous Care
    title: "title",
    sortOrder: "5",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image: "MacroZoom.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Dry Eye Management
    title: "title",
    sortOrder: "6",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image: "Dry Eyes Now.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Corneal & Anterior Segment Care
    title: "title",
    sortOrder: "7",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image: "Corneal & Anterior.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Strabismus & Neuro-Ophthalmology
    title: "title",
    sortOrder: "8",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image: "Strabismus2.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Ocular Trauma & Emergency Care
    title: "title",
    sortOrder: "9",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image: "OccularTrauma.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Oculoplastic Surgery
    title: "title",
    sortOrder: "10",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image: "Eye Comparison.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Pediatric Eye
    title: "title",
    sortOrder: "11",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    image:
      "little-girl-checking-up-her-sight-ophthalmology-center_1303-27499.webp",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Refraction & Optical Shop
    title: "title",
    sortOrder: "12",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    paragraph3: "paragraph3",
    bulletPoints3: "bulletPoints3",
    paragraph4: "paragraph4",
    bulletPoints4: "bulletPoints4",
    paragraph5: "paragraph5",
    bulletPoints5: "bulletPoints5",
    image: "Lens Drops.jpeg",
    image2: "LensCheckup.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Headache Management
    title: "title",
    sortOrder: "13",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    paragraph3: "paragraph3",
    bulletPoints3: "bulletPoints3",
    paragraph4: "paragraph4",
    bulletPoints4: "bulletPoints4",
    image: "Can-Dry-Eyes-Cause-Headaches-Hero.jpg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Ocular Allergy Management
    title: "title",
    sortOrder: "14",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    paragraph3: "paragraph3",
    bulletPoints3: "bulletPoints3",
    paragraph4: "paragraph4",
    bulletPoints4: "bulletPoints4",
    bulletPoints5: "bulletPoints5",
    image: "ERetina.jpeg",
  },
  {
    icon: "assets/img/icon/eye.png",
    // Myopia
    title: "title",
    sortOrder: "15",
    description: "description",
    paragraph1: "paragraph1",
    bulletPoints1: "bulletPoints1",
    paragraph2: "paragraph2",
    bulletPoints2: "bulletPoints2",
    paragraph3: "paragraph3",
    bulletPoints3: "bulletPoints3",
    image: "myopia.jpg",
  },
  // {
  //   icon: "assets/img/icon/eye.png",
  //   title: "Uveitis Treatment",
  //   sortOrder: "15",
  //   description: `Uveitis is the inflammation of the uvea, the middle layer of the eye that supplies nutrients to the retina and other vital structures. It can cause symptoms such as eye redness, pain, light sensitivity, and blurred vision. Uveitis can be associated with a variety of systemic conditions, including autoimmune diseases like rheumatoid arthritis, lupus, and ankylosing spondylitis, as well as infections such as tuberculosis or viral infections. Because of its potential links to other health issues, diagnosing and treating uveitis often requires collaboration between eye specialists and other healthcare providers, such as pulmonologists, rheumatologists, and infectious disease specialists.

  //   To determine the underlying cause of uveitis, various diagnostic tests are performed, including blood tests, X-rays, and sometimes CT scans. In some cases, systemic medications like steroids may be necessary to control inflammation and treat the root cause. Managing uveitis requires a multidisciplinary approach to address both the eye inflammation and any associated systemic conditions that could be contributing to the condition.

  //   `,
  //   paragraph1: `Uveitis can be recurrent, making long-term management and regular follow-ups crucial for effective treatment. If left untreated, chronic uveitis can lead to serious complications like cataracts, increased intraocular pressure (which can lead to glaucoma), and macular edema, a condition affecting the retina. Early diagnosis and treatment are essential to prevent these complications and preserve vision. Timely intervention from an ophthalmologist can significantly reduce the risks of long-term damage.

  //   `,
  //   paragraph2: `Effective management of uveitis requires ongoing care and attention. By treating inflammation early and addressing any underlying conditions, patients can reduce their risk of developing serious complications. Regular check-ups and follow-up visits are necessary to monitor progress and ensure the best possible outcomes for patients.

  //   `,
  //   image:
  //     "medicine-health-care-eyesight-concept-unrecognizable-female-shows-her-inflated-red-eye-with-blood-capillary_176532-9808",
  // },
  //   {
  //     icon: "assets/img/icon/eye.png",
  //     title: "Contact Lens Fitting",
  //     sortOrder: "16",
  //     description: `Contact lenses are a popular alternative to glasses for those seeking clear vision and a more comfortable, unobtrusive option. These lenses are designed to sit directly on the eye's surface, providing a wider field of vision and greater convenience for activities like sports and driving. At Dr. Lakdawala Eye Hospital, we offer a variety of high-quality contact lenses made from advanced materials that prioritize comfort, breathability, and long-lasting durability.

  // Our lenses come in a range of sizes, designs, and colors to suit individual preferences and needs. Whether you require lenses for vision correction, aesthetic purposes, or specialty needs such as astigmatism or presbyopia, we have the right options available. Our team ensures that each lens fits properly, promoting optimal eye health and comfort. With modern technology, we are able to offer high-performance lenses at competitive rates, making them accessible to a broad range of customers.

  //     `,
  //     paragraph1: `Choosing the right contact lenses involves a thorough eye examination and a discussion of your lifestyle needs, including how often you plan to wear them and any specific eye conditions. Our experts work closely with you to determine the best lenses that provide both visual clarity and comfort, whether you are a first-time user or a seasoned contact lens wearer. Regular follow-ups are recommended to monitor eye health and ensure that your lenses continue to meet your needs.

  //     `,
  //     paragraph2: `With proper care and attention, contact lenses can be an excellent solution for clear vision and convenience. Following the correct hygiene practices and wearing instructions is essential for avoiding complications and maintaining eye health. Our team provides comprehensive guidance on lens care, cleaning, and wearing schedules, ensuring that you get the most from your contact lenses while protecting your eyes.

  //     `,
  //     image: "doctor-checking-patient-before-rhinoplasty-side-view_23-2149352177",
  //   },
  //   {
  //     icon: "assets/img/icon/eye.png",
  //     title: "Vision Enhancement & Rehabilitation",
  //     sortOrder: "17",
  //     description: `Uveitis is the inflammation of the uvea, the middle layer of the eye that supplies nutrients to the retina and other vital structures. It can cause symptoms such as eye redness, pain, light sensitivity, and blurred vision. Uveitis can be associated with a variety of systemic conditions, including autoimmune diseases like rheumatoid arthritis, lupus, and ankylosing spondylitis, as well as infections such as tuberculosis or viral infections. Because of its potential links to other health issues, diagnosing and treating uveitis often requires collaboration between eye specialists and other healthcare providers, such as pulmonologists, rheumatologists, and infectious disease specialists.

  //     To determine the underlying cause of uveitis, various diagnostic tests are performed, including blood tests, X-rays, and sometimes CT scans. In some cases, systemic medications like steroids may be necessary to control inflammation and treat the root cause. Managing uveitis requires a multidisciplinary approach to address both the eye inflammation and any associated systemic conditions that could be contributing to the condition.

  //     `,
  //     paragraph1: `Uveitis can be recurrent, making long-term management and regular follow-ups crucial for effective treatment. If left untreated, chronic uveitis can lead to serious complications like cataracts, increased intraocular pressure (which can lead to glaucoma), and macular edema, a condition affecting the retina. Early diagnosis and treatment are essential to prevent these complications and preserve vision. Timely intervention from an ophthalmologist can significantly reduce the risks of long-term damage.

  //     `,
  //     paragraph2: `Effective management of uveitis requires ongoing care and attention. By treating inflammation early and addressing any underlying conditions, patients can reduce their risk of developing serious complications. Regular check-ups and follow-up visits are necessary to monitor progress and ensure the best possible outcomes for patients.

  //     `,
  //     image: "client-ophthalmologist-s-office_52683-135817",
  //   },
  //   {
  //     icon: "assets/img/icon/eye.png",
  //     title: "Squint Eye",
  //     sortOrder: "18",
  //     description: `Squint, also known as strabismus, is a condition where the eyes are not properly aligned, causing them to point in different directions. This can occur in one or both eyes and may result in double vision or poor depth perception. In children, strabismus is often present at birth or develops early in life, and early intervention is key to ensuring proper visual development and preventing long-term vision problems.

  // At Dr. Lakdawala Eye Hospital, we offer specialized care for children with strabismus. Our pediatric ophthalmology services are designed to diagnose and treat a wide range of eye conditions in children, from simple to complex. Strabismus treatment may include corrective lenses, vision therapy, or surgical correction, depending on the severity of the condition and the age of the child. We use the latest technologies and surgical techniques to ensure the best possible outcomes.

  //     `,
  //     paragraph1: `Our pediatric eye care team consists of experienced pediatric ophthalmologists, optometrists, resident physicians, and ophthalmic technicians, all trained to work with children of various ages. We create a friendly, welcoming environment to ensure that your child feels comfortable and relaxed throughout their visit. With a compassionate approach, we provide expert care while addressing both the medical and emotional needs of your child.

  //     `,
  //     paragraph2: `Timely diagnosis and treatment of strabismus are crucial to prevent complications such as amblyopia (lazy eye) or permanent vision impairment. By using a combination of non-invasive treatments and, if necessary, surgery, we can help realign the eyes and restore proper vision. Our pediatric ophthalmologists are dedicated to providing personalized care that meets the specific needs of each child, ensuring the best chance for healthy vision development.

  //     `,
  //     image: "360_F_249187279_zZkHnPHQxcGw8Nq95EPqgDN4mxzZXTSM",
  //   },
];
export const fetchServices = async () => {
  try {
    const updatedServices = services.map((service) => {
      console.log(service.image);

      const updatedService = {
        ...service,
        image: `/assets/img/Services/${service.image}`,
      };

      if (service.image2) {
        updatedService.image2 = `/assets/img/Services/${service.image2}`;
      }

      return updatedService;
    });

    return updatedServices;
  } catch (error) {
    console.error("Error fetching images:", error);
    return services;
  }
};

// export const fetchServices = async () => {
//   try {
//     const storageRef = ref(storage, "services/");
//     const response = await listAll(storageRef);

//     const imageUrls = await Promise.all(
//       response.items.map(async (item) => {
//         // Check if image URL is cached in localStorage
//         const cachedImageUrl = localStorage.getItem(item.name);
//         if (cachedImageUrl) {
//           // Use cached URL if available
//           return { fileName: item.name.split(".")[0], url: cachedImageUrl };
//         } else {
//           // Otherwise, fetch image URL from Firebase and cache it
//           const url = await getDownloadURL(item);
//           localStorage.setItem(item.name, url); // Cache the URL
//           return { fileName: item.name.split(".")[0], url };
//         }
//       })
//     );

//     const updatedServices = services.map((service) => {
//       const matchingImage = imageUrls.find(
//         (img) => img.fileName === service.image
//       );
//       const matchingImage2 = imageUrls.find(
//         (img) => img.fileName === service.image2
//       );
//       return {
//         ...service,
//         image: matchingImage ? matchingImage.url : service.image,
//         image2: matchingImage2 ? matchingImage2.url : service.image2,
//       };
//     });

//     return updatedServices;
//   } catch (error) {
//     console.error("Error fetching images:", error);
//     return services;
//   }
// };
